import { render, staticRenderFns } from "./CreatorCallDispute.vue?vue&type=template&id=29460d3b&"
import script from "./CreatorCallDispute.vue?vue&type=script&lang=js&"
export * from "./CreatorCallDispute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports